<div class="notification-badge" *ngIf="isVisible" [class.closing]="isClosing">
  <div class="notification-content">
    <div class="notification-header">
      <div class="icon-wrapper">
        <ion-icon name="sparkles"></ion-icon>
      </div>
      <h3 class="notification-title">Novidade!</h3>
      <button class="close-btn" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </button>
    </div>
    <p class="notification-text">O portal do colaborador está com um novo estilo!</p>
  </div>
</div>
